import { Field, ObjectType } from "type-graphql";
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, OneToOne, PrimaryGeneratedColumn, UpdateDateColumn } from "typeorm";
import BacklogItemCategory from "./backlog-item-category";
import BacklogLane from "./backlog-lane";

/** An item in the backlog */
@Entity('backlog-item')
@ObjectType()
export default class BacklogItem {
    /** The planning uuid */
    @PrimaryGeneratedColumn('uuid')
    @Field(() => String)
    public uuid: string

    /** The order index within the lane */
    @Column('int', {
        nullable: true
    })
    @Field(() => Number, {
        nullable: true
    })
    public laneOrder: number | null = 0

    /** The order index within the items */
    @Column('int')
    @Field(() => Number)
    public itemOrder: number = 0

    /** The count in the category */
    @Column('int')
    @Field(() => Number)
    public issueNumber: number = 1

    /** The parent of the backlog item */
    @ManyToOne(() => BacklogItem, item => item.children, {
        onDelete: 'SET NULL',
        nullable: true
    })
    @Field(() => BacklogItem, {
        nullable: true
    })
    @JoinColumn()
    public parent: BacklogItem | null = null

    /** The children of the backlog item */
    @OneToMany(() => BacklogItem, item => item.parent, {
        nullable: true
    })
    @Field(() => [BacklogItem], {
        nullable: true
    })
    public children: BacklogItem[]

    /** The item category */
    @ManyToOne(() => BacklogItemCategory, cat => cat.items, {
        onDelete: 'CASCADE',
        nullable: false
    })
    @Field(() => BacklogItemCategory, {
        nullable: true
    })
    @JoinColumn()
    public category: BacklogItemCategory

    /** The item lane */
    @ManyToOne(() => BacklogLane, cat => cat.items, {
        onDelete: 'CASCADE',
        nullable: true
    })
    @Field(() => BacklogLane, {
        nullable: true
    })
    @JoinColumn()
    public lane: BacklogLane | null = null

    /** The title of the backlog item */
    @Column('varchar')
    @Field(() => String)
    public title: string

    /** The description of the backlog item in markdown format */
    @Column('mediumtext', {
        nullable: true
    })
    @Field(() => String, {
        nullable: true
    })
    public markdown: string | null = null
    
    /** The estimated hours this item will take */
    @Column('int')
    @Field(() => Number)
    public hours: number = 1

    /** The created at timestamp */
    @CreateDateColumn({
        type: 'timestamp'
    })
    @Field(() => Date)
    public createdAt: Date

    /** The timestamp at which it was updated */
    @UpdateDateColumn({
        type: 'timestamp',
        name: 'updatedAt'
    })
    @Field(() => Date)
    public updatedAt: Date

    /** Regular non database fields */

    /** Whether the backlog item is expanded in the view */
    public expanded = true

    /** The index */
    public index = 0
}